// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-inventory-page {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding-bottom: 1rem;
}

.add-inventory__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid var(--m-border-color);
  flex-wrap: wrap;
}

.add-inventory__header-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}
.add-inventory__header-title svg {
  flex-shrink: 0;
  opacity: 0.75;
}

.add-inventory__header-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.add-inventory__header-name {
  font-weight: 650;
  color: var(--m-text);
  line-height: 1.2;
}

.add-inventory__header-subtitle {
  font-size: 0.85rem;
  color: var(--m-text-light);
  line-height: 1.2;
}

.add-inventory__form {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 1rem 1.25rem;
  align-items: start;
}

.add-inventory__field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
}

.add-inventory__field--wide {
  grid-column: 1/-1;
}

.add-inventory__selected {
  font-size: 0.85rem;
  color: var(--m-text-light);
  padding-top: 0.25rem;
  min-height: 1.1rem;
}

@media (max-width: 992px) {
  .add-inventory__form {
    grid-template-columns: 1fr;
  }
}
.add-inventory__grid {
  display: grid;
  gap: 1.5rem;
  align-items: start;
}

@media (max-width: 992px) {
  .add-inventory__grid {
    grid-template-columns: 1fr;
  }
}
.add-inventory__meta-card,
.add-inventory__items-card {
  height: auto !important;
  padding: 1.25rem;
  min-height: auto;
}

.add-inventory__section-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 1rem;
  color: var(--m-text);
  flex-wrap: wrap;
}
.add-inventory__section-header svg {
  flex-shrink: 0;
  opacity: 0.7;
}

.add-inventory__summary-badge {
  margin-left: auto;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 0.25rem 0.6rem;
  background: var(--m-background-primary);
  color: white;
  border-radius: 20px;
}

.add-inventory__fields {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.add-inventory__meta-text {
  margin: 0;
  color: var(--m-text-light);
  font-size: 0.9rem;
  line-height: 1.35rem;
}

.add-inventory__search {
  margin-bottom: 1rem;
}

.add-inventory__items-list {
  max-height: 420px;
  overflow-y: auto;
  border: 1px solid var(--m-border);
  border-radius: 8px;
  background: var(--m-card-background-color);
}

.add-inventory__item-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--m-border-color);
  transition: background 0.15s ease;
}
.add-inventory__item-row:last-child {
  border-bottom: none;
}
.add-inventory__item-row:hover {
  background: var(--m-dropdown-hover);
}
.add-inventory__item-row--selected {
  background: var(--m-primary-subtle);
  border-left: 3px solid var(--m-border-primary);
  margin-left: -1px;
  padding-left: calc(1rem + 2px);
}
.add-inventory__item-row--preselected {
  animation: add-inventory-pulse 1.5s ease-out;
}

@keyframes add-inventory-pulse {
  0% {
    background: var(--m-primary-subtle-hovered);
  }
  100% {
    background: var(--m-primary-subtle);
  }
}
.add-inventory__item-info {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 1rem;
  min-width: 0;
  width: 60%;
}

.add-inventory__item-name {
  font-weight: 500;
  color: var(--m-text);
}

.add-inventory__item-code {
  font-size: 0.85rem;
  color: var(--m-text-muted);
}

.add-inventory__item-stock {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.8rem;
  color: var(--m-text-success);
  background: var(--m-background-subtle-success);
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
}

.add-inventory__item-qty {
  flex-shrink: 0;
  width: 240px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  margin-right: 1rem;
  width: 40%;
}

.add-inventory__empty {
  text-align: center;
  padding: 2rem;
  color: var(--m-text-muted);
  font-size: 0.9rem;
}

.add-inventory__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 1rem 0;
  border-top: 1px solid var(--m-border-color);
}

.add-inventory__hint {
  margin: 0;
  font-size: 0.875rem;
  color: var(--m-text-light);
}

.add-inventory__actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  align-self: flex-end;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #666;
}
.loading-container .spin {
  animation: spin 1s linear infinite;
}
.loading-container p {
  margin-top: 16px;
  font-size: 16px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/views/pages/Inventory/AddInventory.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,8CAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AACF;AACE;EACE,cAAA;EACA,aAAA;AACJ;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAAF;;AAGA;EACE,gBAAA;EACA,oBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,0BAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,kBAAA;AAAF;;AAGA;EACE;IACE,0BAAA;EAAF;AACF;AAGA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;AADF;;AAIA;EACE;IACE,0BAAA;EADF;AACF;AAIA;;EAEE,uBAAA;EACA,gBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;AAFF;AAIE;EACE,cAAA;EACA,YAAA;AAFJ;;AAMA;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uCAAA;EACA,YAAA;EACA,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAHF;;AAMA;EACE,SAAA;EACA,0BAAA;EACA,iBAAA;EACA,oBAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,0CAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;EACA,8CAAA;EACA,iCAAA;AAHF;AAKE;EACE,mBAAA;AAHJ;AAME;EACE,mCAAA;AAJJ;AAOE;EACE,mCAAA;EACA,8CAAA;EACA,iBAAA;EACA,8BAAA;AALJ;AAQE;EACE,4CAAA;AANJ;;AAUA;EACE;IACE,2CAAA;EAPF;EASA;IACE,mCAAA;EAPF;AACF;AAUA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;AARF;;AAWA;EACE,gBAAA;EACA,oBAAA;AARF;;AAWA;EACE,kBAAA;EACA,0BAAA;AARF;;AAWA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;EACA,8CAAA;EACA,sBAAA;EACA,kBAAA;AARF;;AAWA;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AARF;;AAWA;EACE,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,iBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,2CAAA;AARF;;AAWA;EACE,SAAA;EACA,mBAAA;EACA,0BAAA;AARF;;AAWA;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;AARF;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AATF;AAUE;EACE,kCAAA;AARJ;AAUE;EACE,gBAAA;EACA,eAAA;AARJ;;AAYA;EACE;IACE,uBAAA;EATF;EAWA;IACE,yBAAA;EATF;AACF","sourcesContent":[".add-inventory-page {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  padding-bottom: 1rem;\n}\n\n.add-inventory__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding-bottom: 1rem;\n  margin-bottom: 1rem;\n  border-bottom: 1px solid var(--m-border-color);\n  flex-wrap: wrap;\n}\n\n.add-inventory__header-title {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 0;\n\n  svg {\n    flex-shrink: 0;\n    opacity: 0.75;\n  }\n}\n\n.add-inventory__header-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.add-inventory__header-name {\n  font-weight: 650;\n  color: var(--m-text);\n  line-height: 1.2;\n}\n\n.add-inventory__header-subtitle {\n  font-size: 0.85rem;\n  color: var(--m-text-light);\n  line-height: 1.2;\n}\n\n.add-inventory__form {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 1rem 1.25rem;\n  align-items: start;\n}\n\n.add-inventory__field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  min-width: 0;\n}\n\n.add-inventory__field--wide {\n  grid-column: 1 / -1;\n}\n\n.add-inventory__selected {\n  font-size: 0.85rem;\n  color: var(--m-text-light);\n  padding-top: 0.25rem;\n  min-height: 1.1rem;\n}\n\n@media (max-width: 992px) {\n  .add-inventory__form {\n    grid-template-columns: 1fr;\n  }\n}\n\n.add-inventory__grid {\n  display: grid;\n  gap: 1.5rem;\n  align-items: start;\n}\n\n@media (max-width: 992px) {\n  .add-inventory__grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.add-inventory__meta-card,\n.add-inventory__items-card {\n  height: auto !important;\n  padding: 1.25rem;\n  min-height: auto;\n}\n\n.add-inventory__section-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  font-size: 0.95rem;\n  margin-bottom: 1rem;\n  color: var(--m-text);\n  flex-wrap: wrap;\n\n  svg {\n    flex-shrink: 0;\n    opacity: 0.7;\n  }\n}\n\n.add-inventory__summary-badge {\n  margin-left: auto;\n  font-size: 0.8rem;\n  font-weight: 500;\n  padding: 0.25rem 0.6rem;\n  background: var(--m-background-primary);\n  color: white;\n  border-radius: 20px;\n}\n\n.add-inventory__fields {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.add-inventory__meta-text {\n  margin: 0;\n  color: var(--m-text-light);\n  font-size: 0.9rem;\n  line-height: 1.35rem;\n}\n\n.add-inventory__search {\n  margin-bottom: 1rem;\n}\n\n.add-inventory__items-list {\n  max-height: 420px;\n  overflow-y: auto;\n  border: 1px solid var(--m-border);\n  border-radius: 8px;\n  background: var(--m-card-background-color);\n}\n\n.add-inventory__item-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--m-border-color);\n  transition: background 0.15s ease;\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  &:hover {\n    background: var(--m-dropdown-hover);\n  }\n\n  &--selected {\n    background: var(--m-primary-subtle);\n    border-left: 3px solid var(--m-border-primary);\n    margin-left: -1px;\n    padding-left: calc(1rem + 2px);\n  }\n\n  &--preselected {\n    animation: add-inventory-pulse 1.5s ease-out;\n  }\n}\n\n@keyframes add-inventory-pulse {\n  0% {\n    background: var(--m-primary-subtle-hovered);\n  }\n  100% {\n    background: var(--m-primary-subtle);\n  }\n}\n\n.add-inventory__item-info {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem 1rem;\n  min-width: 0;\n  width: 60%;\n}\n\n.add-inventory__item-name {\n  font-weight: 500;\n  color: var(--m-text);\n}\n\n.add-inventory__item-code {\n  font-size: 0.85rem;\n  color: var(--m-text-muted);\n}\n\n.add-inventory__item-stock {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-size: 0.8rem;\n  color: var(--m-text-success);\n  background: var(--m-background-subtle-success);\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n}\n\n.add-inventory__item-qty {\n  flex-shrink: 0;\n  width: 240px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.75rem;\n  margin-right: 1rem;\n  width: 40%;\n}\n\n.add-inventory__empty {\n  text-align: center;\n  padding: 2rem;\n  color: var(--m-text-muted);\n  font-size: 0.9rem;\n}\n\n.add-inventory__footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 1rem;\n  flex-wrap: wrap;\n  padding: 1rem 0;\n  border-top: 1px solid var(--m-border-color);\n}\n\n.add-inventory__hint {\n  margin: 0;\n  font-size: 0.875rem;\n  color: var(--m-text-light);\n}\n\n.add-inventory__actions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n  align-self: flex-end;\n}\n\n// Loading (shared with Inventory)\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #666;\n  .spin {\n    animation: spin 1s linear infinite;\n  }\n  p {\n    margin-top: 16px;\n    font-size: 16px;\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
